import {
    type ViewStyle
} from "react-native";
import type {
    BubbleReactionsChipDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../../../types";
import {
    getElevationStyle
} from "../../../../../../helpers/theme/elevation";
import {
    getFocusRingStyle
} from "../../../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../../../helpers/theme/control";

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    isPressable,
    pointerType,
    shadowAlpha,
    elevations,
    typography,
    radiuses,
    borders,
    colors,
    spaces,
    isOwn
}: BubbleReactionsChipDynamicStyleType) => {
    const chipHeight = controlHeights.small - shapeConfigs.chipHeightOffset;

    const hitArea = getHitArea({
        visualSize: chipHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            backgroundColor: isOwn ? colors.content.container.selected : colors.content.container.raised,
            borderColor: isOwn ? colors.content.border.default : colors.content.border.subtle,
            paddingHorizontal: spaces.spacingXs,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            }),
            borderWidth: borders.line,
            gap: spaces.spacingXs,
            height: chipHeight
        } as Mutable<ViewStyle>,
        chip: {
            minHeight: isPressable ? hitArea.minHeight : chipHeight
        } as Mutable<ViewStyle>,
        emoji: {
            lineHeight: typography.labelSmallSize.lineHeight
        } as Mutable<ViewStyle>
    };

    if(!isOwn) {
        Object.assign(styles.surface, getElevationStyle({
            shadowColor: colors.system.shadow,
            level: "level1",
            shadowAlpha,
            elevations
        }));
    }

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
